import Vue from 'vue'
import moment from 'moment'

// 设置本地时区
moment.locale('zh-cn')
Vue.prototype.moment = moment

export function timeFromNow(time) {
  const format = "YYYY-MM-DD HH:mm:ss";
  const formatDate = "YYYY-MM-DD";
  const formatTime = "HH:mm:ss";
  let timeStr = moment(time).format(format);
  if (moment(time).format(formatDate) === moment().format(formatDate)) {
    const fromNowStr = moment(time).fromNow(true);
    if (fromNowStr.indexOf("小时") > 0 && parseInt(fromNowStr) > 5) {
      timeStr = "今天 " + moment(time).format(formatTime);
    } else {
      timeStr = fromNowStr + "前"
    }
  }
  return timeStr
}
// 计算时间差
export function handleDate(dateTimeStamp) {
  var minute = 1000 * 60;
  var hour = minute * 60;
  var day = hour * 24;
  var result = '';
  var now = new Date().getTime();
  //   console.log(now)
  var oldTime = new Date(dateTimeStamp.replace(/-/g, '/')).getTime()
  //   console.log(oldTime)
  var diffValue = now - oldTime;
  if (diffValue < 0) {
    console.log("时间不对劲,服务器创建时间与当前时间不同步");
    return result = "刚刚";
  }
  var dayC = diffValue / day;
  var hourC = diffValue / hour;
  var minC = diffValue / minute;
  if (parseInt(dayC) > 7) {
    result = "" + moment(dateTimeStamp).format('YYYY-MM-DD');
  } else if (parseInt(dayC) > 1) {
    result = "" + parseInt(dayC) + "天前";
  } else if (parseInt(dayC) == 1) {
    result = "昨天";
  } else if (hourC >= 1) {
    result = "" + parseInt(hourC) + "小时前";
  } else if (minC >= 3) {
    result = "" + parseInt(minC) + "分钟前";
  } else
    result = "刚刚";
  return result;
}